import classNames from 'classnames';
import { useEffect, useState } from 'react';
import EfVideo from '@elem/ui/ef-video';
import { useMediaDevice } from '../../hooks';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23" fill="none">
        <path
            d="M9.49026 16.1446C11.973 16.1446 13.9856 14.1117 13.9856 11.6038C13.9856 9.09603 11.973 7.06305 9.49026 7.06305C7.00753 7.06305 4.99487 9.09603 4.99487 11.6038C4.99487 14.1117 7.00753 16.1446 9.49026 16.1446Z"
            fill="#D8D8D8"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.4752 18.2111C4.05002 17.9394 3.64686 17.6357 3.27173 17.3033C1.41674 15.6489 0.397362 13.4462 0.397468 11.0977C0.397468 8.75154 1.41685 6.55046 3.26783 4.89974C5.79837 2.6443 9.66324 1.20049 14.7554 0.607929L19.9795 0L15.5044 3.98847C15.9296 4.26004 16.3326 4.5638 16.7079 4.89624C18.5582 6.54664 19.5753 8.74845 19.5753 11.0997C19.5753 13.451 18.5583 15.6529 16.7119 17.2998C14.181 19.5553 10.3161 20.9993 5.22387 21.5917L0 22.1994L4.4752 18.2111Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.98899 8.07264C8.33405 8.07264 6.99207 9.42733 6.99207 11.0998C6.99207 12.7723 8.33405 14.127 9.98899 14.127C11.6439 14.127 12.9859 12.7723 12.9859 11.0998C12.9859 9.42733 11.6439 8.07264 9.98899 8.07264ZM13.9495 4.03638L12.0004 5.77341C12.9077 6.04168 13.7429 6.50384 14.4455 7.12646C16.906 9.32096 16.906 12.8787 14.4455 15.0732C12.6296 16.6916 9.82298 17.7216 6.02716 18.1633L7.97627 16.4262C7.06897 16.1579 6.23381 15.6958 5.53114 15.0732C3.07071 12.8787 3.056 9.33396 5.53114 7.12646C7.34708 5.50801 10.1537 4.47804 13.9495 4.03638Z"
            fill="#566CFF"
        />
    </svg>
);

export default function TheComp() {
    const { isPC, isDesktop, isPad, isH5 } = useMediaDevice();
    const { t } = useLang('Oasis.SmartBackup2');

    const [enter, setEnter] = useState(0);
    useEffect(() => {
        const info = document.querySelector('#SmartBackup2 .info') as HTMLDivElement;
        const videoContainer = document.querySelector('#SmartBackup2 .video-container') as HTMLDivElement;
        const scene1 = AniContainer.create({
            triggerElement: '#SmartBackup2', // 触发元素
            triggerHook: 1, // 触发时机 1 进入 0 离开
            duration: '100%',
            offset: isPad ? '10%' : '20%',
            onProcess: (process: number) => {
                if (process < 0.2) {
                    info.style.opacity = '0';
                } else if (process < 0.3) {
                    const opacity = ((process - 0.2) / (0.3 - 0.2)).toFixed(2);
                    info.style.opacity = opacity;
                } else {
                    info.style.opacity = '1';
                }

                if (process < 0.4) {
                    videoContainer.style.opacity = '0';
                } else if (process < 0.7) {
                    const opacity = ((process - 0.4) / (0.7 - 0.4)).toFixed(2);
                    videoContainer.style.opacity = opacity;
                }
            },
            onEnter: () => {
                setEnter(1);
            }, // 进入
        });
        const scene2 = AniContainer.create({
            triggerElement: '#SmartBackup2',
            duration: '100%',
            triggerHook: 1,
            offset: '150%',
            onEnter: () => {
                setEnter(2);
            },
        });

        return () => {
            scene1.destroy();
            scene2.destroy();
        };
    }, [isPC, isDesktop, isPad, isH5]);

    // 懒加载视频
    const [loaderVideo1, setLoaderVideo1] = useState(false);
    const [loaderVideo2, setLoaderVideo2] = useState(false);
    useEffect(() => {
        const loader1 = AniContainer.create({
            triggerElement: '#SmartInsights',
            triggerHook: 1,
            offset: 0,
            duration: '100%',
            onEnter: () => {
                setLoaderVideo1(true);
            },
        });
        const loader2 = AniContainer.create({
            triggerElement: '#SmartInsights',
            triggerHook: 1,
            offset: 0,
            duration: '100%',
            onEnter: () => {
                setLoaderVideo2(true);
            },
        });
        return () => {
            loader1.destroy();
            loader2.destroy();
        };
    }, []);
    return (
        <div className={`${styles.TheComp}`} id="SmartBackup2">
            <div className="sticky">
                <div className="info">
                    <div className="left">
                        <div className="label">
                            {icon}
                            <span>{t('label')}</span>
                        </div>
                        <div className="title">{t('title')}</div>
                    </div>
                    <div className="right desc">{t('desc')}</div>
                </div>

                <div className="video-container">
                    {loaderVideo1 &&
                        (isPC || isDesktop ? (
                            <EfVideo
                                className={classNames('video1', { enter: [0, 1].includes(enter) })}
                                pc="https://websiteoss.ecoflow.com/upload/video/1735633579374/SmartBackup2.mp4"
                                poster="https://websiteoss.ecoflow.com/upload/image/1735636448957/SmartBackup2-poster.jpg"
                                startPlay={enter === 1}
                                loop
                                key="video1-pc"
                                preload="none"
                            />
                        ) : (
                            <EfVideo
                                className={classNames('video1', { enter: [0, 1].includes(enter) })}
                                pc="https://websiteoss.ecoflow.com/upload/video/1735633587796/SmartBackup2-h5.mp4"
                                poster="https://websiteoss.ecoflow.com/upload/image/1735637623434/SmartBackup2-poster-h5.jpg"
                                startPlay={enter === 1}
                                loop
                                key="video1-h5"
                                preload="none"
                            />
                        ))}
                    {loaderVideo2 &&
                        (isPC || isDesktop ? (
                            <EfVideo
                                className={classNames('video2', { enter: [2].includes(enter) })}
                                pc="https://websiteoss.ecoflow.com/upload/video/1735633579205/SmartBackup3.mp4"
                                poster="https://websiteoss.ecoflow.com/upload/image/1735636449294/SmartBackup3-poster.jpg"
                                startPlay={enter === 2}
                                loop
                                key="video2-pc"
                                preload="none"
                            />
                        ) : (
                            <EfVideo
                                className={classNames('video2', { enter: [2].includes(enter) })}
                                pc="https://websiteoss.ecoflow.com/upload/video/1735633587623/SmartBackup3-h5.mp4"
                                poster="https://websiteoss.ecoflow.com/upload/image/1735637623261/SmartBackup3-poster-h5.jpg"
                                startPlay={enter === 2}
                                loop
                                key="video2-h5"
                                preload="none"
                            />
                        ))}
                </div>
            </div>
        </div>
    );
}
